export type DragDropStemSegment =
	| { type: "text"; value: string; key: string }
	| { type: "blank"; blankId: string; key: string };

export type DragDropStemRow = DragDropStemSegment[];

const BLANK_TOKEN_REGEX = /((?:\\)?\{(?:\\)?\{blank(?:\\)?_[^}]+\}\})/g;
const PARAGRAPH_BREAK_REGEX = /\n{2,}/;

const normalizeBlankId = (raw: string) => raw.replace(/\\_/g, "_");

const parseRowSegments = (
	text: string,
	keyForText: (index: number) => string,
): DragDropStemSegment[] => {
	let textIndex = 0;
	return text
		.split(BLANK_TOKEN_REGEX)
		.filter(Boolean)
		.map((part) => {
			const match = part.match(/^(?:\\)?\{(?:\\)?\{(blank(?:\\)?_[^}]+)\}\}$/);
			if (match) {
				const blankId = normalizeBlankId(match[1]);
				return { type: "blank", blankId, key: blankId } as const;
			}
			return {
				type: "text",
				value: part,
				key: keyForText(textIndex++),
			} as const;
		});
};

export const parseDragDropStemRows = (text: string): DragDropStemRow[] =>
	text
		.split(PARAGRAPH_BREAK_REGEX)
		.map((paragraph, rowIndex) =>
			parseRowSegments(paragraph, (i) => `text-r${rowIndex}-${i}`),
		)
		.filter((row) => row.length > 0);

export const parseDragDropStemSegments = (
	text: string,
): DragDropStemSegment[] => parseRowSegments(text, (i) => `text-${i}`);
